import React from 'react';
import PropTypes from 'prop-types';

import { ListSubheader as MUIListSubheader } from '@mui/material';

export const ListSubheader = props => <MUIListSubheader {...props} />;

ListSubheader.propTypes = {
  classes: PropTypes.object,
  color: PropTypes.oneOf(['default', 'primary', 'inherit']),
  component: PropTypes.elementType,
  disableGutters: PropTypes.bool,
  disableSticky: PropTypes.bool,
  inset: PropTypes.bool
};

export default ListSubheader;
